<script lang="ts">
export enum DrawerPosition {
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}
</script>

<script setup lang="ts">
export interface TcNavigationDrawerProps {
  position?: DrawerPosition;
  width?: number;
  isOpen?: boolean;
}

const props = withDefaults(defineProps<TcNavigationDrawerProps>(), {
  width: 320,
  position: DrawerPosition.LEFT,
  isOpen: false,
});
</script>

<template>
  <div
    class="drawer"
    :class="{
      'drawer--left': props.position === DrawerPosition.LEFT,
      'drawer--right': props.position === DrawerPosition.RIGHT,
      'drawer--open': props.isOpen === true,
    }"
    :style="{
      'max-width': `${props.width}px`,
      left: props.isOpen === true ? '0px' : `-${props.width}px`,
    }"
  >
    <slot />
  </div>
</template>

<style scoped lang="scss">
.drawer {
  display: flex;
  position: absolute;
  height: 100%;
  background-color: white;
  transition: left 0.2s;
  z-index: 100;
  width: 100%;
  max-width: 720px;

  &--open {
  }
}
</style>
